module.exports = __webpack_public_path__ + "img/equal-not.62e6115b.svg";